import {
  SET_WELCOME_DATA,
  GET_WELCOME_DATA,
  SET_RECENT_POPUP_STRATEGY,
  SET_WELCOME_INIT,
  ADD_WELCOMEIDS_TO_DOWNLOAD,
} from '../constants/welcome';

export const setWelcomeData = payload => ({
  type: SET_WELCOME_DATA,
  payload,
});

export const setWelcomeInit = payload => ({
  type: SET_WELCOME_INIT,
  payload,
});
export const getWelcomeData = payload => ({
  type: GET_WELCOME_DATA,
  payload,
});

export const setRecentPopopStrategy = payload => ({
  type: SET_RECENT_POPUP_STRATEGY,
  payload,
});

export const addWelcomeIdToDownload = ids => ({
  type: ADD_WELCOMEIDS_TO_DOWNLOAD,
  ids,
});
